import { PropsWithChildren } from 'react'

type RootProps = {}

export const Root = ({ children }: PropsWithChildren<RootProps>) => {
  return <div className="h-screen">{children}</div>
}
